import { FunctionComponent, useMemo } from 'react'

import { WParagraph } from '@alice-health/wonderland-react'
import {
  useMarkers,
  useFilters,
  useList
} from '@/modules/accredited-establishments/hooks'

const FiltersController: FunctionComponent = () => {
  const { markers } = useMarkers()
  const { establishmentsCount } = useList()

  const { isListView } = useFilters()

  const optionsCount = useMemo(() => {
    const count = isListView ? establishmentsCount : markers.length

    return count === 1 ? '1 opção disponível' : `${count} opções disponíveis`
  }, [isListView, establishmentsCount, markers])

  return (
    <WParagraph className='w-fit tablet-landscape:max-w-[80px]'>
      {optionsCount}
    </WParagraph>
  )
}

export { FiltersController }
